import React from "react";

function Refund(){
    return(
        <div>
            
            <div className="pageBanner lifeAtELite_banner">
                <div className="bannerCover d-flex  flex-column justify-content-center align-items-center text-center">
                    <h2 className='main_heading titleFont_style text-light pt-4'>Refund Policy</h2>
                </div>
            </div>

            <section class="bg-light section_padding">
                <div class="container">
                    <p>
                        At Elite Techlogix we are committed to ensuring the highest level of service. 
                        Whilst we trust you are pleased with the service you received. 
                        We do not offer any refund under normal conditions. We only offer conditional 
                        refund if you face quality issues with the services.
                    </p>

                    <p>
                        If you find any issue or discrepancy in the quality of our services, 
                        please report it to us within 48 hours of service delivery. Once your query is received, 
                        our Quality Assurance department will review the matter and get back to you promptly. 
                        After evaluation, we may offer a service revision or adjustment in case of any major concern identified.
                    </p>

                    <p>
                        Moreover, services those are customized or given a discount on are not eligible for Refund or Chargeback.
                    </p>

                    <h6>Contact Us:</h6>

                    <p>
                        If you have any questions or concerns about our refund policy or the refund process, 
                        please feel free to contact our support team at Phone number +92-42-35833800
                        Email: info@elitetechlogix.com. We are here to assist you.
                    </p>

                    <p>
                        By acquiring a service with Elite Techlogix, you agree to adhere to our refund policy.
                    </p>

                    <p>
                        Thank you for choosing us for your servicing needs.
                    </p>
                </div>
            </section>
        </div>
    )
}

export default Refund;